import React, {useState} from 'react';
import {
  StyledInputNumberRangeWrapper,
  Typography,
} from './InputNumberRange.style';
import Input from '../Input/Input';
import {FormControl} from '@mui/material';
type numberRangeProps = {
  start?: string | number;
  end?: string | number;
};

interface InputNumberRangeProps {
  values: numberRangeProps;
  onChange: (name: any, e: any) => void;
}
const InputNumberRange = ({values, onChange}: InputNumberRangeProps) => {
  // Function to handle changes in the input fields
  const handleChange = (e: {target: {name: any; value: any}}) => {
    const {name, value} = e.target;
    onChange(name, e);
  };

  return (
    <StyledInputNumberRangeWrapper
      display="flex"
      alignItems="center"
      gap={2}
      height={35}
    >
      {/* Start Number Input */}
      <FormControl fullWidth margin="none">
        <Input
          name="start"
          type="number"
          variant="outlined"
          value={values.start}
          onChange={handleChange}
          placeholder="From"
          inputMode="numeric"
          sx={{
            marginBottom: '0 !important',
            '.MuiInputBase-input': {
              padding: '8px 12px',
            },
          }}
        />
      </FormControl>

      {/* Dash Between Inputs */}
      <Typography variant="h6">-</Typography>

      {/* End Number Input */}
      <FormControl fullWidth margin="none">
        <Input
          name="end"
          variant="outlined"
          type="number"
          value={values.end}
          onChange={handleChange}
          placeholder="To"
          inputMode="numeric"
          sx={{
            marginBottom: '0 !important',
            '.MuiInputBase-input': {
              padding: '8px 12px',
            },
          }}
        />
      </FormControl>
    </StyledInputNumberRangeWrapper>
  );
};

export default InputNumberRange;
